import React, { useContext } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingBar from "react-top-loading-bar";
import Dashboard from "./components/Dashboard";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Profile from "./components/Profile";
import ScrollToTop from "./components/ScrollToTop";
import SwapFrame from "./components/SwapFrame";
import Tickets from "./components/Tickets";
import { Context } from "./context/context";
import LoaderImg from "./images/loader.svg";

function App() {
  const { darkMode, setProgress, progress } = useContext(Context);
  return (
    <div className="App">
      <div
        className={`horizontalMenucontainer  ${
          darkMode ? "dark-theme" : "light-theme"
        }`}
      >
        <div id="global-loader" style={{ display: "none" }}>
          <img src={LoaderImg} className="loader-img" alt="Loader" />
        </div>
        <div className="page">
          <LoadingBar
            color="#1353FF"
            progress={progress}
            height={4}
            onLoaderFinished={() => setProgress(0)}
          />
          <Router>
            <ScrollToTop>
              <ToastContainer pauseOnFocusLoss={false} />
              <Header />
              <Switch>
                <Route exact path="/">
                  <Dashboard />
                </Route>
                <Route exact path="/account">
                  <Profile />
                </Route>
                <Route exact path="/swap">
                  <SwapFrame />
                </Route>
                <Route exact path="/tickets">
                  <Tickets />
                </Route>
              </Switch>
              <Footer />
            </ScrollToTop>
          </Router>
        </div>
      </div>
    </div>
  );
}

export default App;
